export default function PhaseButton({ onClick, isActive, isDisabled, children }) {
  return (
    <button
      className={`PhaseBtn phase-btn ${isActive ? "is-active" : ""} ${isDisabled ? "is-disabled" : ""}`}
      onClick={onClick}
      disabled={isDisabled}
    >
      {children}
    </button>
  );
}